import styled, { createGlobalStyle } from "styled-components";

import FlexContainer from "@/components/FlexContainer";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

const positionPaddingValues = {
    top: "0 0 16px 0",
    bottom: "16px 0 0 0",
    center: "16px 0",
};

export const StyledCBBlock = styled(FlexContainer)<{
    position: "top" | "bottom" | "center";
}>`
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;
    border-bottom: 1px solid #313131;
    gap: 4px;
    padding: ${(props) => positionPaddingValues[props.position]};
`;

export const StyledCBTitle = styled(SecondaryText)`
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
`;

export const StyledCBText = styled(PrimaryText)`
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
`;

export const CBGlobalStyle = createGlobalStyle`
    .switch-form {
        background-color: #15325B !important;
    }
    .switch-form.ant-switch-checked {
        background-color: #144848 !important;
    }
`;
